import Backbone from "backbone";
import * as _ from "underscore";

import * as mustcache from "mustcache";

const PrivateLibraryTagSelectorView = Backbone.View.extend({
  initialize: function (options) {
    this.options = options;
    this.models = options.models;
    this.listenTo(
      this.models.bookTags,
      "add remove change:count",
      this.render.bind(this)
    );
    this.listenTo(
      this.models.shelves,
      "add remove change:books change:name",
      this.render.bind(this)
    );
    this.render();
  },
  render: function () {
    const templateData: { options: any[] } = {
      options: [],
    };
    const bookTagsViewJSON = this.models.bookTags.viewJSON();

    if (this.options.searchQuery.get("query").length > 0) {
      templateData.options.push({
        displayName:
          'Search for "' + this.options.searchQuery.get("query") + '"',
        active: true,
      });
      templateData.options.push({ displayName: " ", disabled: true });

      _.each(bookTagsViewJSON.tags, (tag) => {
        tag.active = false;
      });
    }

    templateData.options.push(
      _.findWhere(bookTagsViewJSON.tags, { name: "all" })
    );

    templateData.options.push({ displayName: " ", disabled: true });
    templateData.options.push({
      displayName: "---- Read Status ----",
      disabled: true,
    });
    templateData.options.push(
      _.findWhere(bookTagsViewJSON.tags, { name: "queue" })
    );
    templateData.options.push(
      _.findWhere(bookTagsViewJSON.tags, { name: "completed" })
    );
    templateData.options.push(
      _.findWhere(bookTagsViewJSON.tags, { name: "abandoned" })
    );

    templateData.options.push({ displayName: " ", disabled: true });
    templateData.options.push({
      displayName: "---- Shared ----",
      disabled: true,
    });
    templateData.options.push(
      _.findWhere(bookTagsViewJSON.tags, { name: "shared" })
    );

    if (this.models.shelves.length > 0) {
      templateData.options.push({ displayName: " ", disabled: true });
      templateData.options.push({
        displayName: "---- Shelves ----",
        disabled: true,
      });

      this.models.shelves.each((shelf) => {
        templateData.options.push({
          displayName: shelf.get("name"),
          count: shelf.get("bookCount") || shelf.get("books").length,
          showCount: true,
          value: "shelf:" + shelf.id,
          active: shelf.id === this.models.shelves.getSelectedShelfID(),
        });
      });

      /*
        templateData.options.push({
          displayName: 'Un-Shelved',
          count: _.findWhere(bookTagsViewJSON.tags, {name: 'all'}).count - _.keys(booksOnShelves).length,
          showCount: true,
          value: 'shelf:unshelved',
          active: this.models.shelves.getSelectedShelfID() === 'unshelved'
        });
       */
    }

    templateData.options.push({ displayName: " ", disabled: true });
    templateData.options.push({
      displayName: "---- Deleted ----",
      disabled: true,
    });
    templateData.options.push(
      _.findWhere(bookTagsViewJSON.tags, { name: "deleted" })
    );

    mustcache.render("privateLibrarySelector", templateData, (html) => {
      this.$el.html(html);
    });
  },
  events: {
    change: "changeTag",
  },
  changeTag: function () {
    const selected = this.$("select").val();
    const shelfMatch = /^shelf:(.*)$/.exec(selected);

    this.options.searchQuery.set("query", "");

    if (shelfMatch && shelfMatch[1]) {
      if (shelfMatch[1] === "allTexts") {
        this.models.shelves.setSelectedShelfID(null);
      } else {
        this.models.shelves.setSelectedShelfID(shelfMatch[1]);
      }
      this.models.bookTags.setActiveTag(null);
    } else {
      this.models.shelves.setSelectedShelfID(null);
      this.models.bookTags.setActiveTag(selected);
    }
  },
});

export default PrivateLibraryTagSelectorView;
